import ProjectWebscannerScanHistoryModule from './scan-history.module'

export default ProjectWebscannerScanHistoryModule
